import { Component, h, Prop, Element } from '@stencil/core';
import { injectCSS } from '../../utils';
import { createStyles } from './flex-item-styles';
import {
  TFlexGrow,
  TFlexItemAlignSelf,
  TFlexItemFlex,
  TFlexItemOffset,
  TFlexItemWidth,
  TFlexShrink,
} from './flex-item-utils';

@Component({
  tag: 'dc-ui-flex-item',
  shadow: true,
})
export class DcUiFlexItem {
  @Element() host!: HTMLElement;
  /** Defines how this flex item is aligned along the cross axis */
  @Prop() alignSelf?: TFlexItemAlignSelf = 'auto';
  /** The shorthand property for the combined definition of shrink, grow and basis */
  @Prop() flex?: TFlexItemFlex = 'initial';
  /** The ability to allow/disallow the flex child to grow */
  @Prop() grow?: TFlexGrow = 0;
  /** The ability to allow/disallow the flex child to shrink */
  @Prop() shrink?: TFlexShrink = 0;
  /** Defines the offset of this flex item */
  @Prop() offset?: TFlexItemOffset = 'none';
  /** Defines the width of this flex item */
  @Prop() width?: TFlexItemWidth = 'auto';

  render() {
    injectCSS(
      this.host,
      createStyles,
      this.alignSelf,
      this.flex,
      this.grow,
      this.shrink,
      this.offset,
      this.width
    );

    return <slot />;
  }
}
